import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../themes/default-theme';
import ModelLogo from '../../components/multimedia/ModelLogo';
import ModelSelectModel from '../../components/multimedia/ModelSelectModel';
import { useRouter } from 'next/router';

const Wrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    background: ${theme.palette.lightGrey};
    display: inline-block;
    width: 100%;
    ${theme.breakpoints.up('lg')} {
        padding-left: 40px;
        padding-right: 40px;
    }
`
const Container = styled.div`
    max-width: 1400px;
    margin: auto;
`

const modelStepOnePageDefaultPropSeriesUrl = {};
const modelStepOnePageDefaultPropModelLogo = {};
const modelStepOnePageDefaultPropModelSelectModel = {};
const modelStepOnePageDefaultPropModelPrice = {};

const ModelStepOnePage = (props) => {
    props = {
        ...props,
        seriesName: typeof props.seriesName === "undefined" ? null : props.seriesName,
        seriesUrl: typeof props.seriesUrl === "undefined" ? modelStepOnePageDefaultPropSeriesUrl : props.seriesUrl,
        modelLogo: typeof props.modelLogo === "undefined" ? modelStepOnePageDefaultPropModelLogo : props.modelLogo,
        modelSelectModel: typeof props.modelFloorplan === "undefined" ? modelStepOnePageDefaultPropModelSelectModel : props.modelFloorplan,
        modelPrice: typeof props.modelPrice === "undefined" ? modelStepOnePageDefaultPropModelPrice : props.modelPrice,
        buildPriceDisclaimer: typeof props.buildPriceDisclaimer === "undefined" ? null : props.buildPriceDisclaimer
    };

    const {
        seriesName,
        seriesUrl,
        modelLogo,
        modelSelectModel,
        modelPrice,
        disablePrice,
        buildPriceDisclaimer,
        countryProps
    } = props

    const router = useRouter();
    const [showBuildAndPrice, setShowBuildAndPrice] = useState(true);

    // Media Breakpoint Start
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End

    // useEffect(() => {
    //     if((document.location.hostname == 'www.jaycoadelaide.com.au') || (document.location.hostname == 'www.jaycoalbertpark.com.au') || (document.location.hostname.indexOf('jayco-com-au.au1.staticlyproject.com') > -1) || (document.location.hostname.indexOf('localhost') > -1)) {
    //       setShowBuildAndPrice(true);
    //     } else {
    //       setShowBuildAndPrice(false);
    //       router.push('/404');
    //     }
    // }, [])

    // Set Dynamic width
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const ref = useRef(null);
    const ref2 = useRef(null);
    const [width, setWidth] = useState(0);
    const[containerWidth, setConntainerWidth] = useState(0);
    useEffect(() => {
        if (ref.current && ref.current.clientWidth) {
            setWidth(ref.current.clientWidth);
        }
        function handleWindowResize() {
            if (ref.current && ref.current.clientWidth) {
                setWidth(ref.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize);

        if (ref2.current && ref2.current.clientWidth) {
            setConntainerWidth(ref2.current.clientWidth);
        }
        function handleWindowResize2() {
            if (ref2.current && ref2.current.clientWidth) {
                setConntainerWidth(ref2.current.clientWidth);
            }
        }
        window.addEventListener('resize', handleWindowResize2);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('resize', handleWindowResize2);
        };

    }, [media]);

    return (
        showBuildAndPrice &&
        <>
            <ModelLogo
                {...modelLogo}
            />
            <Wrapper ref={ref}>
                
                <div ref={ref2} style={{maxWidth: '1400px', margin: '0 auto', height: 0, overflow: 'hidden'}} />

                <ModelSelectModel
                    {...modelSelectModel}
                    modelPrice={modelPrice}
                    currentWidth={(width - containerWidth)/2}
                    disablePrice={disablePrice}
                    countryProps={countryProps}
                    buildPriceDisclaimer={buildPriceDisclaimer}
                />
            

            </Wrapper>
        </>
    )
}

ModelStepOnePage.propTypes = {
    seriesName: propTypes.string,
    seriesUrl: propTypes.object,
    modelLogo: propTypes.object,
    modelSelectModel: propTypes.object,
    modelPrice: propTypes.object,
    buildPriceDisclaimer: propTypes.string

}

export default ModelStepOnePage